import { render, staticRenderFns } from "./LeaveTypes.vue?vue&type=template&id=ff649f22&scoped=true"
import script from "./LeaveTypes.vue?vue&type=script&lang=js"
export * from "./LeaveTypes.vue?vue&type=script&lang=js"
import style0 from "./LeaveTypes.vue?vue&type=style&index=0&id=ff649f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff649f22",
  null
  
)

export default component.exports